import styled from "styled-components";
import Skeleton from "react-loading-skeleton";

export const BannerLoaderBlock = styled(Skeleton)`
  width: 348px;
  height: 400px;
  margin-bottom: 16px;
`;
